import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useI18n } from "./i18n";
import { DemoStore } from "./screens/DemoStore";
import { ErrorState } from "./screens/ErrorState";
import { Home } from "./screens/Home";
import { PayPage } from "./screens/PayPage";
import { StatusPage } from "./screens/StatusPage";
import { CardLoading } from "./screens/v2/common";

// public pages load on demand; the payment page stays in the main bundle.
const LinkPage = lazy(() => import("./screens/v2/LinkPage").then((m) => ({ default: m.LinkPage })));
const BillingPage = lazy(() => import("./screens/v2/BillingPage").then((m) => ({ default: m.BillingPage })));
const SubscriptionPage = lazy(() => import("./screens/v2/SubscriptionPage").then((m) => ({ default: m.SubscriptionPage })));
const RefundClaimPage = lazy(() => import("./screens/v2/RefundClaimPage").then((m) => ({ default: m.RefundClaimPage })));
const TopUpPage = lazy(() => import("./screens/v2/TopUpPage").then((m) => ({ default: m.TopUpPage })));
const SignupPage = lazy(() => import("./screens/v2/SignupPage").then((m) => ({ default: m.SignupPage })));

function SkipLink() {
  const { t } = useI18n();
  return (
    <a className="skip-link" href="#main">
      {t("common.skip")}
    </a>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <SkipLink />
      <Suspense fallback={<CardLoading />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pay/:id" element={<PayPage />} />
          <Route path="/i/:id" element={<StatusPage />} />
          <Route path="/demo" element={<DemoStore />} />
          {/* Public URLs exactly as the server builds them, plus short aliases. */}
          <Route path="/l/:handle/:slug" element={<LinkPage />} />
          <Route path="/billing/:token" element={<BillingPage />} />
          <Route path="/b/:token" element={<BillingPage />} />
          <Route path="/subscriptions/:token" element={<SubscriptionPage />} />
          <Route path="/s/:token" element={<SubscriptionPage />} />
          <Route path="/refund/:token" element={<RefundClaimPage />} />
          <Route path="/r/:token" element={<RefundClaimPage />} />
          <Route path="/topup/:id" element={<TopUpPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="*" element={<ErrorState code="not_found" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
